import { useQuery } from "@tanstack/react-query";
import { DepartmentInterface } from "../../../models/TicketModule/Department";
import { CACHE_KEY_DEPARTMENTS } from "../../../utils/constants";
import departmentService from "../../../services/ticketService/departmentService";

const useDepartmentById = (id: string) =>
  useQuery<DepartmentInterface, Error>({
    queryKey: [`${CACHE_KEY_DEPARTMENTS}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, statusId] = queryKey;
      return departmentService.GetById(statusId as string);
    },
    enabled: !!id,
  });

export default useDepartmentById;
